export enum MarginVisibility {
  NO_VISIBILITY = 'NO_VISIBILITY',
  SLIDER_MARGIN_ONLY = 'SLIDER_MARGIN_ONLY',
  SLIDER_AND_TOTAL_MARGIN = 'SLIDER_AND_TOTAL_MARGIN',
}
